import { Injectable } from '@angular/core';
import { BasePagedCrudService } from "../shared/crud/base-crud.service";
import { IdentityUserCreateDto, IdentityUserDto, IdentityUserUpdateDto } from "./models/UserDtos";
import { HttpClient } from "@angular/common/http";
import { CrudSettings, QueryParams } from "../shared/crud/abstractions/base-crud";
import { EnvironmentService } from '../core/environment/environment.service';
import {DialogService} from "../shared/dialog/dialog.service";
import {MatSnackBar} from "@angular/material/snack-bar";

export class UserCrudSettings implements CrudSettings<string, IdentityUserDto> {
  baseUrl = '';
  postUrl = undefined;
  queryParam = undefined;
  createSuffix = undefined;
  deleteSuffix = undefined;
  deleteIdLocation: 'PATH' | 'QUERY' = 'PATH';
  editSuffix = undefined;
  editIdLocation: 'PATH' | 'QUERY' = 'PATH';
  editMethod: 'PUT' | 'PATCH' = 'PUT';
  getListSuffix = undefined;
  getSuffix = undefined;
  getIdLocation: 'PATH' | 'QUERY' = 'PATH';
  idGetter = (entity: IdentityUserDto) => entity.id;

  mapper(id: string): QueryParams {
    const dict = new Map<string, string>();
    dict.set('id', id);
    return { params: dict }
  }

  constructor(private environmentService: EnvironmentService) {
    this.baseUrl = this.environmentService.getConfig().api.baseUrl + '/api/identity/users';
  }
}

@Injectable({
  providedIn: null
})
export class UserDataService
  extends BasePagedCrudService<string, IdentityUserDto, IdentityUserCreateDto, IdentityUserUpdateDto>{

  constructor(private _http: HttpClient, private environmentService: EnvironmentService, override dialogService: DialogService) {
    super(_http, new UserCrudSettings(environmentService),dialogService);
  }
}
